import { JSX } from 'preact'
import { useEffect } from 'preact/hooks'
import { ActionType, WidgetLayout } from '@gsc/types'
import { setDocumentStyles } from '../Style'
import { useActions } from '../useActions'
import { Form } from '../Form'
import { SystemButton } from './SystemButton'
import { StyleImages } from '../StyleImage/StyleImages'
import { Logo } from '../Logo'
import { LayoutProps } from './interfaces'
import { BlockTree } from '../Blocks/BlockTree'

const useDocumentStyles = (layout: WidgetLayout) => {
  useEffect(() => {
    if (layout === WidgetLayout.Modal || layout === WidgetLayout.Fullscreen) {
      setDocumentStyles({ overflow: 'hidden' })
      return () => setDocumentStyles({ overflow: null })
    }
  }, [layout])
}

export function GeneralLayout(props: LayoutProps): JSX.Element {
  const { layout, hasPreviousPage, page, className, innerRef, closeButton, backButton } = props
  const { root } = page

  const hasClose = closeButton ? closeButton.visible : layout !== WidgetLayout.Inline
  const hasBack = (backButton?.visible ?? true) && hasPreviousPage
  const processActions = useActions()
  const navigateBack = () => processActions([{ type: ActionType.Back }])
  const close = () => processActions([{ type: ActionType.CloseWidget }])

  useDocumentStyles(layout)

  return (
    <div ref={innerRef} className={className} role="dialog">
      <Form {...root}>
        <StyleImages />
        {root.children.map(c => (
          <BlockTree root={c} />
        ))}
        {hasBack && <SystemButton name="back" {...backButton} onClick={navigateBack} />}
        {hasClose && <SystemButton name="close" {...closeButton} onClick={close} />}
      </Form>
      <Logo />
    </div>
  )
}
